<template>
  <div class="current-rides container-fluid r-aside">
    <loading :active.sync="isLoading"
             :can-cancel="true">
    </loading>

    <div class="row page-titles">
        <div class="col-md-5 align-self-center">
            <h3 class="text-themecolor">{{ title }}</h3>
        </div>
        <div class="col-md-7 align-self-center">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="javascript:void(0)">Home</a></li>
                <li class="breadcrumb-item active">{{ title }}</li>
            </ol>
        </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <form class="form-material">
              <div class="row">
<!--                <div class="col-md-4 col-lg-4 p-0">-->
<!--                  <div class="m-3">-->
<!--                    <label class="search-label">Driver Email</label>-->
<!--                    <input v-model="current_driver_email" class="form-control form-control-sm" placeholder="Driver Email" style="width:100%" type="text"-->
<!--                           id="current_ride_search_driver_email">-->
<!--                  </div>-->
<!--                </div>-->
                <div class="col-md-2 col-lg-2 p-0">
                  <div class="m-3">
                    <label class="search-label">Driver First Name</label>
                    <input v-model="current_driver_name_first" class="form-control form-control-sm" placeholder="Driver First Name" style="width:100%" type="text"
                           id="current_ride_search_driver_firstname">
                  </div>
                </div>
                <div class="col-md-2 col-lg-2 p-0">
                  <div class="m-3">
                    <label class="search-label">Driver Last Name</label>
                    <input v-model="current_driver_name_last" class="form-control form-control-sm" placeholder="Driver Last Name" style="width:100%" type="text"
                           id="current_ride_search_driver_lastname">
                  </div>
                </div>
                <!-- <div class="col-md-4 col-lg-4 p-0">
                  <div class="m-3">
                    <label class="search-label">Rider Email</label>
                    <input v-model="current_rider_email" class="form-control form-control-sm" placeholder="Rider Email" style="width:100%" type="text"
                           id="current_ride_search_rider_email">
                  </div>
                </div> -->
                <div class="col-md-2 col-lg-2 p-0">
                  <div class="m-3">
                    <label class="search-label">Rider First Name</label>
                    <input v-model="current_rider_name_first" class="form-control form-control-sm" placeholder="Rider First Name" style="width:100%" type="text"
                           id="current_ride_search_rider_firstname">
                  </div>
                </div>
                <div class="col-md-2 col-lg-2 p-0">
                  <div class="m-3">
                    <label class="search-label">Rider Last Name</label>
                    <input v-model="current_rider_name_last" class="form-control form-control-sm" placeholder="Rider Last Name" style="width:100%" type="text"
                           id="current_ride_search_rider_lastname">
                  </div>
                </div>

                <div class="col-md-2 col-lg-2 p-0">
                  <div class="m-3">
                    <label class="search-label">From</label>
                    <input v-model="current_ride_pickup" class="form-control form-control-sm" placeholder="From" style="width:100%" type="text"
                           id="current_ride_search_pickup_address">
                  </div>
                </div>
                <div class="col-md-2 col-lg-2 p-0">
                  <div class="m-3">
                    <label class="search-label">To</label>
                    <input v-model="current_ride_dropoff" class="form-control form-control-sm" placeholder="To" style="width:100%" type="text"
                           id="current_ride_search_dropoff_address">
                  </div>
                </div>
                <div class="col-md-2 col-lg-2 p-0">
                  <div class="m-3">
                    <label class="search-label">Select a Status</label>
                    <select type="text" placeholder="Market"
                            class="form-control ddown" id="status-filter" v-model="current_ride_status">
                      <option v-bind:value=null>
                        All
                      </option>
                      <option v-for="(index, item) in data.filters.status" v-bind:value="index">
                        {{item.replace(item.charAt(0), item.charAt(0).toUpperCase()).replace("_", " ").replace("_", " ").replace("linear", "General").replace("logarithmic", "Accelerated")}}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-2 col-lg-2 p-0">
                  <div class="m-3">
                    <label class="search-label">Market</label>
                    <select type="text" placeholder="Market" class="form-control ddown" id="market-filter" v-model="selected_market">
                      <option v-bind:value="'All'" >
                        All
                      </option>
                      <option v-for="market in markets" v-bind:value="market" v-bind:key="market.id_market">
                        {{ market.name }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="col-md-2 col-lg-2 p-0">
                  <div class="m-3">
                    <label class="search-label">Ride Type</label>
                    <select type="text" placeholder="Ride Type"
                            class="form-control ddown" id="ride-type-filter" v-model="selected_ride_type">
                      <option v-bind:value="'All'">
                        All
                      </option>
                      <option v-bind:value="0">
                        Regular
                      </option>
                      <option v-bind:value="1">
                        Deadhead
                      </option>
                    </select>
                  </div>
                </div>

                <div class="col-md-2 col-lg-2 p-0">
                  <div class="m-3 form-ddown">
                    <label class="search-label">Beginning Date</label>
                    <datetime type="datetime" v-model="min_date" input-class="form-control form-control-sm" placeholder="Min Departure Date" label="Min Departure Date" :noClearButton="false">
                    </datetime>
                    <font-awesome-icon v-if="min_date" @click="clearDate('min_date')" icon="times" style="color: red; cursor: pointer"/>
                  </div>
                </div>
                <div class="col-md-4 col-lg-4 p-0">
                  <div class="m-3 form-ddown">
                    <label class="search-label">Maximum Date</label>
                    <datetime type="datetime"  v-model="max_date" label="Max Departure Date" input-class="form-control form-control-sm" placeholder="Max Departure Date" >
                    </datetime>
                    <font-awesome-icon v-if="max_date" @click="clearDate('max_date')" icon="times" style="color: red; cursor: pointer"/>
                  </div>
                </div>
                <div class="col-12 m-3 p-0 submit-button">
                  <a @click="currentButtonSearch()" style="color: white" class="btn btn-info waves-effect waves-light m-t-10" > Search </a>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="result">
              <div class="table-responsive">
                <table class="table table-hover table-sm">
                  <thead>
                    <tr>
                      <th style="width: 100px">
                        Page Size
                      </th>
                      <th>
                        <select v-model="perPage" class="form-control table-select" @change="checkPageSize($event)">
                          <option v-for="size in page_sizes">
                            {{size}}
                          </option>
                        </select>
                      </th>
                    </tr>
                    <br>
                    <tr>
                      <th class="result-label" v-for="(column) in data.resultColumns" v-on:click="sortResults($event)">
                        <div class="nowrap" style="">
                          {{column}}
                          <div class="arrow-down" v-bind:id="column" style="visibility: hidden; margin-left: 5px;"></div>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody class="col-12">
                  <tr v-for="ride in data.sortedRides">
                    <td class="result-item nowrap">
                      <router-link :to="'/rides/' + ride.id_ride + '/'">
                        <!--<router-link :to="{name: 'Rides', params: {id_ride: ride.id_ride}}">-->
                        {{ ride.id_ride }}
                      </router-link>
                    </td>
                    <td class="result-item nowrap">
                      <router-link :to="'/rides/' + ride.id_ride + '/'">
                        <!--<router-link :to="{name: 'Rides', params: {id_ride: ride.id_ride}}">-->
                        {{ ride.id_alternate }}
                      </router-link>
                    </td>
                    <td class="result-item nowrap" >
                      <router-link :to="'/search-rides/?id_group_ride=' + ride.id_group_ride" v-if="ride.id_group_ride" style="padding: 0.3rem;" target="_blank">
                        {{ ride.id_group_ride }}
                      </router-link>

                      <component v-if="!ride.id_group_ride">{{ 'N/A' }}</component>
                    </td>
                    <td class="result-item nowrap">
                      {{ ride.id_type_ride_status && ride.id_type_ride_status.name ? ride.id_type_ride_status.name : 'N/A' }}</td>
                    <td class="result-item nowrap">
                      {{ ride.deadhead && ride.deadhead == 1 ? 'Deadhead' : 'Regular' }}</td>
                    <td class="result-item nowrap">
                      <router-link v-if="ride.id_rider" :to="'/users/' + ride.id_rider.id_user + '/'">
                        {{ (ride.contact_first_name ? ride.contact_first_name : ride.id_rider.name_first) + " " + (ride.contact_last_name ? ride.contact_last_name : ride.id_rider.name_last) }}
                        <br>
                      </router-link>
                      <!--<span v-if="ride.id_rider" class="">{{ ride.id_rider.email }}</span>-->
                    </td>
                    <td class="result-item nowrap">
                      <router-link v-if="ride.id_driver" :to="'/drivers/' + ride.id_driver.id_user + '/'">
                        {{ ride.id_driver.name_first + ' ' + ride.id_driver.name_last }}
                        <br>
                      </router-link>
                      <!--<span v-if="ride.id_driver" class="">{{ ride.id_driver.email }}</span>-->
                    </td>
                    <td class="result-item nowrap">
                      <span class="">
                        <!--{{ moment(ride.date_pickup).format("YYYY-MM-DD HH:mm")  + " (" + moment.tz(moment.tz.guess()).format('z') + ")" }}-->
                        {{ !ride.date_pickup ? 'N/A' : ride.local_timezone ? moment.utc(ride.date_pickup).tz(ride.local_timezone).format('MMMM Do YYYY, h:mm:ss a (z)') : moment.utc(ride.date_pickup).format('MMMM Do YYYY, h:mm:ss a (z)')}}
                      </span>
                    </td>
                    <td class="result-item" v-bind:style="ride.info.includes('late') ? 'color:red' : ride.info.includes('left') ? 'color:green' : ride.info.includes('Expire') ? 'color:orange' : ride.info.includes('Departure') ? 'color:red' : 'color: black'">
                      <span class="">{{ ride.info }}</span>
                    </td>
                    <td class="result-item">
                      <span class="">{{ ride.default_pickup_address }}</span>
                    </td>
                    <td class="result-item">
                      <span class="">{{ ride.default_dropoff_address }}</span>
                    </td>
<!--                    <td class="result-item">-->
<!--                      <span v-if="ride.id_business_provider != null">{{ ride.id_business_provider.name_first + " " + ride.id_business_provider.name_last }}</span>-->
<!--                    </td>-->
                  </tr>
                  </tbody>
                </table>

                <div style="background-color: rgba(0, 0, 0, 0.05); float: left; width: 100%;">
                  <div style="margin: 1rem 1rem; float: left;">
                    <span v-if="totalRows > 0">Showing {{ perPage * (currentPage-1) + 1 }} to {{ perPage * currentPage > totalRows ? totalRows : perPage * currentPage }} of {{ totalRows }} entries</span>
                    <span v-else>Showing 0 entries</span>                  </div>
                  <div style="margin: 0 1rem; float: right;">
                    <b-pagination style="margin: .5rem 0;" align="center" :total-rows=totalRows v-model="currentPage" :per-page=perPage :limit=limit @change="changePage">
                    </b-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay'
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css'

  export default {
    metaInfo: {
      title: 'Wingz Support | Current Rides',
    },
    name: "CurrentRides",
    data () {
      return {
        title: 'Current Rides',
        current_ride_status: null,
        current_rider_email: null,
        current_rider_name_first: null,
        current_rider_name_last: null,
        current_driver_email: null,
        current_driver_name_first: null,
        current_driver_name_last: null,
        current_ride_pickup: null,
        current_ride_dropoff: null,
        selected_market: "All",
        selected_ride_type: 'All',
        min_date: null,
        max_date: null,
        page_sizes: [20, 50, 100],
        markets: null,
        data: {
          rides: [],
          filteredRides: [],
          sortedRides: [],
          filters: {
            status: {
              "unassigned":15,
              "accepted":7,
              "en-route":10,
              "picked-up":11,
              "dropped-off":12,
              "distributing_linear":16,
              "distributing_logarithmic":17,
              "expired":18,
              "canceled":23,
              "canceled_by_rider":2,
              "canceled_by_support":3,
              "rider_no_show":8,
              "driver_no_show":9,
              "paid_denied":24
            }
          },
          resultColumns: ["Ride ID", "Leg ID", "Trip ID", "Ride Status", "Ride Type" ,"Rider", "Driver", "Pick-up Date", "Info", "From", "To"],
          sortDirection: 0,
        },
        isLoading: false,
        currentPage: 1,
        totalRows: 0,
        perPage: 20,
        limit: 10,
        errors: null,
      }
    },
    components: {
      Loading
    },
    methods: {
      currentSearch: function (page) {
        this.isLoading = true
        this.$http
          .get(process.env.API_BASE_URL_CS + 'rides/?type=current'
            + (this.current_ride_status == null ? '' : '&id_type_ride_status=' + this.current_ride_status)
            + (this.current_rider_email == null || this.current_rider_email.length==0 ? '' : '&contact_email__icontains=' + this.current_rider_email)
            + (this.current_rider_name_first == null || this.current_rider_name_first.length==0 ? '' : '&contact_first_name__icontains=' + this.current_rider_name_first)
            + (this.current_rider_name_last == null || this.current_rider_name_last.length==0 ? '' : '&contact_last_name__icontains=' + this.current_rider_name_last)
            + (this.current_driver_email == null || this.current_driver_email.length==0 ? '' : '&id_driver__email__icontains=' + this.current_driver_email)
            + (this.current_driver_name_first == null || this.current_driver_name_first.length==0 ? '' : '&id_driver__name_first__icontains=' + this.current_driver_name_first)
            + (this.current_driver_name_last == null || this.current_driver_name_last.length==0 ? '' : '&id_driver__name_last__icontains=' + this.current_driver_name_last)
            + (this.current_ride_pickup == null || this.current_ride_pickup.length==0 ? '' : '&default_pickup_address__icontains=' + this.current_ride_pickup)
            + (this.current_ride_dropoff == null || this.current_ride_dropoff.length==0 ? '' : '&default_dropoff_address__icontains=' + this.current_ride_dropoff)
            + (this.selected_market == "All" ? '' : '&id_market=' + this.selected_market.id_market)
            + (this.min_date == null ? '' : '&date_pickup__gte=' + this.min_date)
            + (this.max_date == null ? '' : '&date_pickup__lte=' + this.max_date)
            + (this.selected_ride_type == null || this.selected_ride_type == 'All' ? '' : '&deadhead=' + this.selected_ride_type)
            + '&ordering=' + (this.prev_sort ? (this.prev_sort.getAttribute('value')>0 ? '' : '-') + this.prev_sort.getAttribute('name') : '')
            + '&page=' + (page ? page : this.currentPage)
            + '&page_size=' + (this.perPage)
          )
          .then(response => {
            this.data.rides = response.data.results
            this.data.filteredRides = this.data.rides.slice(0)
            this.data.sortedRides = this.data.rides.slice(0)

            if (response.data && response.data.count) {
              this.totalRows = response.data.count
            }
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            console.log(error)
            this.errored = true
          })
          .finally(() => this.isLoading = false)
      },
      currentButtonSearch(page) {
        this.resetPager()
        this.currentSearch(page)
      },
      getMarkets: function () {
        this.isLoading = true
        this.$http
          .get(process.env.API_BASE_URL_CS + 'markets/')
          .then(response => {
            this.markets = response.data
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            Vue.toasted.show('Something went wrong!', {
              theme: 'bubble',
              position: 'top-right',
              duration: 2000
            })
            console.log(error.response)
            this.errors = error.response.data
            this.non_field_errors = error.response.data.non_field_errors
          })
      },

      changePage: function (page) {
        this.currentSearch(page)
      },
      checkPageSize: function(event) {
        this.currentSearch()
      },
      resetPager: function () {
        this.currentPage = 1
        this.totalRows = 0
      },
      clearDate(date) {
        if (date == 'min_date') {
          this.min_date = null
        }
        if (date == 'max_date') {
          this.max_date = null
        }
      },
    },
    mounted () {
      this.currentSearch()
      this.getMarkets()
    },
    created () {
      // document.title = "Wingz Support | Current Rides";
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .table td {
    vertical-align: middle;
  }
  .table th > div {
    position: relative;
    display: inline;
  }
  .table th > div .arrow-down {
    position: absolute;
    right: -13px;
    top: 40%;
  }
  .table-responsive {
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/CurrentRides.vue